import { createSlice } from "@reduxjs/toolkit";

interface IMaintenanceSessionState {
  isBypassed: boolean;
}

export const maintenanceSessionInitialState: IMaintenanceSessionState = {
  isBypassed: false,
};

const maintenanceSessionSlice = createSlice({
  name: "maintenanceSession",
  initialState: maintenanceSessionInitialState,
  reducers: {
    bypassMaintenance(state) {
      state.isBypassed = true;
    },
    resetBypass(state) {
      state.isBypassed = false;
    },
  },
});

export const { bypassMaintenance, resetBypass } =
  maintenanceSessionSlice.actions;

export default maintenanceSessionSlice.reducer;
